import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function ProofSection() {
  const timeline = [{
    time: 'Primeras 12 horas',
    description: 'Tu sistema nervioso se calma y dejas de retener líquido.'
  }, {
    time: 'Segundo día',
    description: 'Tus enzimas digestivas comienzan a desglosar alimentos estancados.'
  }, {
    time: 'Tercer día',
    description: 'La pared de tu colon se desinflama, permitiendo que tu abdomen recupere su forma natural y tu piel luzca más radiante.'
  }];
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#FAFAF7'
  }} data-id="element-195">
      <div className="max-w-4xl mx-auto px-4" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-197">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-4" style={{
          color: '#1A1A1A'
        }} data-id="element-198">
            ¿Qué sucede en tu cuerpo en 72 horas?
          </h2>

          <p className="text-center text-lg mb-12" style={{
          color: '#4A4A4A'
        }} data-id="element-199">
            La ciencia detrás del protocolo:
          </p>

          <div className="relative" data-id="element-200">
            <div className="absolute left-6 md:left-8 top-0 bottom-0 w-0.5" style={{
            backgroundColor: '#C9A96E'
          }} data-id="element-201" />

            <div className="space-y-8" data-id="element-202">
              {timeline.map((item, index) => <motion.div key={index} className="relative flex gap-6 md:gap-8" initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} data-id="element-203">
                  <div className="w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center flex-shrink-0 z-10" style={{
                backgroundColor: '#C9A96E'
              }} data-id="element-204">
                    <ClockIcon className="w-6 h-6 md:w-8 md:h-8 text-white" data-id="element-205" />
                  </div>

                  <div className="flex-1 bg-white rounded-2xl p-5 md:p-6 shadow-sm" style={{
                border: '1px solid #C5DDD1'
              }} data-id="element-206">
                    <h3 className="text-lg md:text-xl font-semibold mb-2" style={{
                  color: '#C9A96E'
                }} data-id="element-207">
                      {item.time}
                    </h3>
                    <p className="text-base md:text-lg" style={{
                  color: '#4A4A4A'
                }} data-id="element-208">
                      {item.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}